import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import { FloatingButtons } from "./components/FloatingButtons";

import { Home } from "./pages/Home";
import { ServicesPage } from "./pages/ServicesPage";
import { FacilitiesPage } from "./pages/FacilitiesPage";
import { DoorstepPage } from "./pages/DoorstepPage";
import { MembershipsPage } from "./pages/MembershipsPage";
import { AboutPage } from "./pages/AboutPage";
import { ContactPage } from "./pages/ContactPage";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="bg-[#080808] min-h-screen text-white overflow-x-hidden flex flex-col justify-between">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/facilities" element={<FacilitiesPage />} />
            <Route path="/doorstep" element={<DoorstepPage />} />
            <Route path="/memberships" element={<MembershipsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
        <FloatingButtons />
      </div>
    </Router>
  );
}

export default App;
